<roma-modal-template
  [title]="'sequence.add' | translate"
  [subtitle]="'sequence.subtitle' | translate"
  [headerBottomMargin]="'24px'"
  [showDefaultButtons]="true"
  [contentMinHeight]="false"
  [isLoading]="isSubmitting"
  size="lg"
  (success)="submit()"
  (cancel)="close()"
  [showCancelBtn]="false"
  class="modal-create-sequence"
  [showTutorialLink]="tutorialExists()"
  (tutorialLink)="openTutorialVideo()"
  [actionsAlign]="alignActionStyle()"
>
  <div class="row" #rowContainer>
    <!-- Form Section -->
    <div class="col-lg-7 col-md-12 col-sm-12 form-section">
      <div class="form-group">
        <label for="prefix">
          {{ 'sequence.prefix' | translate }}
          <span class="required">*</span>
          <img
            style="padding-left: 5px"
            tooltipDir
            [tooltipBackground]="'black'"
            [tooltipMessages]="['sequence.tooltips.prefix']"
            [tooltipPosition]="'right'"
            [tooltipShowOn]="'any'"
            [tooltipHideOn]="'any'"
            src="/assets/icons/gl_information-fill-gray.svg"
          />
        </label>
        <input
          type="text"
          class="form-control"
          id="prefix"
          aria-describedby="emailHelp"
          maxLength="50"
          [placeholder]="'sequence.prefixPlaceholder' | translate"
          [(ngModel)]="sequence.prefix"
          [ngClass]="{ 'is-invalid': submitError && prefixError }"
        />
        <div *ngIf="submitError && prefixError" class="invalid-feedback">
          {{ prefixError | translate }}
        </div>
      </div>

      <div class="form-group">
        <label for="currentNumber">
          {{ 'sequence.actualValue' | translate }}
          <span class="required">*</span>
          <img
            style="padding-left: 5px"
            tooltipDir
            [tooltipBackground]="'blue'"
            [tooltipMessages]="['sequence.tooltips.startNumber1']"
            [tooltipPosition]="'bottom'"
            [tooltipShowOn]="'any'"
            [tooltipHideOn]="'any'"
            src="/assets/icons/gl_information-fill-gray.svg"
          />
        </label>
        <input
          type="number"
          class="form-control"
          id="currentNumber"
          aria-describedby="emailHelp"
          maxLength="20"
          [(ngModel)]="sequence.currentNumber"
          (paste)="onPaste($event)"
          (keypress)="onKeyPress($event)"
          (change)="onChangeCurrentNumber()"
          pattern="[0-9]*"
        />
      </div>

      <div class="form-group">
        <label for="name">
          {{ 'sequence.name' | translate }}
          <span class="required">*</span>
        </label>
        <input
          type="text"
          class="form-control"
          id="name"
          aria-describedby="emailHelp"
          maxLength="50"
          [placeholder]="'sequence.namePlaceholder' | translate"
          [(ngModel)]="sequence.name"
          [ngClass]="{ 'is-invalid': submitError && sequence.name === '' }"
        />
        <div
          *ngIf="submitError && sequence.name === ''"
          class="invalid-feedback"
        >
          {{ 'sequence.nameRequired' | translate }}
        </div>
      </div>

      <div class="form-group" *ngIf="showIncrement">
        <label for="increment"> {{ 'sequence.increment' | translate }} </label>
        <input
          type="text"
          class="form-control"
          id="increment"
          aria-describedby="emailHelp"
          maxLength="50"
          [(ngModel)]="sequence.incrementValue"
        />
      </div>

      <div class="form-group" *ngIf="!disableList">
        <label for="type"> {{ 'sequence.type' | translate }} </label>
        <ng-select
          [(ngModel)]="sequence.type"
          [clearable]="false"
          id="type"
          (open)="onSelectOpen()"
          #typeSelect
        >
          <ng-container *ngFor="let item of types">
            <ng-option
              *ngIf="item !== sequenceTypeRef.ADD_BUDGETS"
              [value]="item"
            >
              {{ getTranslationBySequenceType(item) }}
            </ng-option>
          </ng-container>
        </ng-select>
      </div>
    </div>

    <!-- Preview Section -->
    <div class="col-lg-5 col-md-12 col-sm-12 preview-section">
      <div class="preview-header">
        <span class="preview-title">{{ 'sequence.preview' | translate }}</span>
      </div>
      <div class="preview-content">
        <div class="document-skeleton">
          <div class="document-header">
            <div class="preview-document">
              {{ getPreviewDocumentType() }} {{ getPreviewNumber() }}
            </div>

            <div class="skeleton-logo"></div>
          </div>

          <div class="skeleton-client-info">
            <div class="skeleton-client-column">
              <div class="skeleton-line"></div>
              <div class="skeleton-line thin"></div>
              <div class="skeleton-line thin"></div>
            </div>
            <div class="skeleton-client-column">
              <div class="skeleton-line"></div>
              <div class="skeleton-line thin"></div>
              <div class="skeleton-line thin"></div>
            </div>
          </div>

          <div class="skeleton-table-header">
            <div class="skeleton-header-cell"></div>
          </div>

          <div class="skeleton-table-row">
            <div class="cell-description">
              <div class="skeleton-table-cell long"></div>
              <div class="skeleton-table-cell medium"></div>
            </div>
            <div class="cell-items">
              <div class="skeleton-table-cell short"></div>
              <div class="skeleton-table-cell short"></div>
              <div class="skeleton-table-cell short"></div>
            </div>
          </div>

          <div class="skeleton-table-row total-row">
            <div class="cell-items">
              <div class="skeleton-table-cell short"></div>
              <div class="skeleton-table-cell short"></div>
            </div>
          </div>
          <div class="skeleton-table-row total-row">
            <div class="cell-items">
              <div class="skeleton-table-cell short"></div>
              <div class="skeleton-table-cell short"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</roma-modal-template>
